import { Flex, Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART, U_KEY } from '@app/constants';
import {
  useWarehousesRegistry,
  useWarehousesRegistryEffects,
} from '@app/pages/Warehouses/WarehouseRegistry/hooks';
import type { WarehousesRegistryColumns } from '@app/pages/Warehouses/WarehouseRegistry/types';
import { WarehousesRegistryFilters } from '@app/pages/Warehouses/WarehouseRegistry/ui';
import { FiltersAccordion } from '@app/shared/components';

import type { FC } from 'react';

import '@pages/Warehouses/WarehouseRegistry/ui/WarehousesRegistry.scss';

export const WarehousesRegistry: FC = () => {
  const {
    filtersForm,
    selectedBranches,
    setSelectedBranches,
    isLoading,
    pageNumber,
    rowsPerPage,
    totalRowsCount,
    handleChangePagination,
    allBranches,
    handleSearch,
    resetSearch,
    tableData,
    tableColumns,
    isMobile,
    initialFilterPayload,
    searchWarehousesHandler,
    getBranchesForSystemHandler,
    isPageForbidden,
  } = useWarehousesRegistry();

  useWarehousesRegistryEffects({
    initialFilterPayload,
    searchWarehousesHandler,
    getBranchesForSystemHandler,
  });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className="WarehousesRegistry">
      <Flex vertical className="WarehousesRegistry__content">
        <div className="WarehousesRegistry__filters-section">
          <FiltersAccordion>
            <WarehousesRegistryFilters
              filtersForm={filtersForm}
              selectedBranches={selectedBranches}
              setSelectedBranches={setSelectedBranches}
              allBranches={allBranches}
              handleSearch={handleSearch}
              resetSearch={resetSearch}
            />
          </FiltersAccordion>
        </div>

        <div className="WarehousesRegistry__table-section">
          <Table<WarehousesRegistryColumns>
            className="WarehousesRegistry__table"
            columns={tableColumns}
            dataSource={tableData}
            loading={isLoading}
            rowKey={(record) => record[U_KEY]}
            size={isMobile ? 'small' : 'middle'}
            scroll={{ x: 720 }}
            pagination={{
              responsive: true,
              size: isMobile ? 'small' : 'default',
              showSizeChanger: true,
              total: totalRowsCount,
              pageSize: rowsPerPage,
              position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
              current: pageNumber,
              onChange: handleChangePagination,
              showLessItems: isMobile,
              showTotal: (total, range) =>
                isMobile
                  ? `Всего ${total}`
                  : `Показаны результаты с ${range[0]} по ${range[1]} из ${total}`,
            }}
          />
        </div>
      </Flex>
    </div>
  );
};
